<template>
  <v-layout row align-center pa-2 my-1 class="event-in-list">
    <v-flex shrink class="ma-1">
      <v-icon color="deep-purple">event</v-icon>
    </v-flex>
    <v-flex>
      <ul class="unstyled">
        <li class="body-2">{{ event.event_date | moment("dddd, MMMM DD") }}</li>
        <li>
          <router-link
            :to="{ name: 'eventDetail', params: { eventId: event.event_id } }"
            class="unstyled-link"
          >
            <span class="title">{{ event.event_title }}</span>
          </router-link>
        </li>
        <li class="subtle body-2">
          {{ event.event_date | moment("h:mma") }}<span v-if="event.event_end"> - {{ event.event_end | moment("h:mma") }}</span>
        </li>
        <li v-if="event.location" class="subtle body-2">{{ event.location }}</li>
        <li class="subtle body-2">{{ rsvpStatus }}</li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['event'],
  computed: {
    rsvpStatus () {
      if (!this.event.responded) return "Haven't responded"
      return this.event.attending ? 'Going' : 'Not Going'
    },
  },
}
</script>

<style scoped>
.event-in-list {
  border-left: 3px solid #673ab7;
}
</style>
